import { ENV } from '@/services/config/env-config';

export const appInfo = {
  // learn more about this on https://supertokens.com/docs/thirdpartyemailpassword/appinfo
  appName: 'DigiProc',
  apiDomain: ENV.SUPERTOKENS_API_DOMAIN,
  websiteDomain: ENV.SUPERTOKENS_WEBSITE_DOMAIN,
  apiBasePath: '/v2/auth',
  websiteBasePath: '/auth',
};
